import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Indian currency formatting function
export function formatIndianCurrency(amount: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount).replace('₹', '').trim();
}

// Alternative function that returns just the formatted number without currency symbol
export function formatIndianNumber(amount: number): string {
  return new Intl.NumberFormat('en-IN').format(amount);
}

// Safe price parsing function to handle different data types
export function parsePrice(price: any): number {
  if (typeof price === 'number') {
    return price;
  }
  if (typeof price === 'string') {
    return parseFloat(price.replace(/,/g, ''));
  }
  // Fallback for any other type
  return parseFloat(String(price).replace(/,/g, ''));
}
